<div>
  <app-header></app-header>
  <main>
    <router-outlet />
  </main>
  <app-footer></app-footer>
  <app-announcement-popup></app-announcement-popup>
</div>
